import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
//import { SSO } from '../../helper/api';

export class Sso extends Component {
  static propTypes = {
    authentification: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  /*componentWillMount(){
    this.ticket = SSO.getTicket(this.props.location.search);

    if(!this.ticket){
      SSO.goTo('login');
    } else {
      SSO.getData(this.ticket)(this.props.actions.auth)
    }
  }*/

  render() {

    return null
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    authentification: state.authentification,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sso);



// WEBPACK FOOTER //
// ./src/features/authentification/Sso.js